var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-main"},[_c('ctint-router-page-content',{attrs:{"namespace":_vm.namespace,"routerItems":_vm.routerItems},on:{"openSelectedTask":_vm.openSelectedTask}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }